import React, { Component } from 'react';
import { Button, Card, CardBody, Col, CustomInput, Input, Label, Modal, ModalBody, ModalHeader, Row, Badge, Form, UncontrolledTooltip } from 'reactstrap';
import { deleteAPI, getAPI, postAPI, postMultiPartAPI, putAPI } from '../Base/API';
import { BlankCard, StyledCard, MultiLangText, getMultiLangEmpty, getCardAmountTagLanguages } from '../Base/Common/CommonUIComponents';
import { getRebateActions, getPromoteTypes, getTaxCodes, processMultilingualTexts, getMonetaryVoucherActions } from '../Base/Common/ReferenceDataFunctions';
import DragAndDrop from "../Base/Common/DragAndDrop";
import { handleNotification } from "../Base/Common/Notification";
import { VoucherPreview } from "./VoucherPreview";
import CustomSelect from "../Base/Common/CustomSelect";
import { FormattedMessage, injectIntl } from 'react-intl';
import { ImageDragAndDrop } from "./ImageDragAndDrop";
import Authorization, { CheckAuthorization } from '../Base/Authorization';
import VoucherConfigStep1 from "./VoucherConfigStep1";
import VoucherConfigStep8 from './VoucherConfigStep8';
import VoucherConfigStepImages from './VoucherConfigStepImages';


export class CardConfigWizard extends Component {
    static displayName = CardConfigWizard.name;
    _isMounted = false;
    constructor(props) {
        super(props);
        this.getConfigDetails = this.getConfigDetails.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleModalPreview = this.toggleModalPreview.bind(this);
        this.handleSwitched = this.handleSwitched.bind(this);
        this.updateTerm = this.updateTerm.bind(this);

        this.state = {
            block: false,
            blockTemplateImages: false,
            isDragMode: false,
            steps: [
                { step: '1', active: true, enabled: true },
                { step: '2', active: false, enabled: true },
                { step: '3', active: false, enabled: true },
                { step: '4', active: false, enabled: true },
                { step: '5', active: false, enabled: true },
                { step: '6', active: false, enabled: true },
                { step: '7', active: false, enabled: true },
                { step: '8', active: false, enabled: true }
            ],
            files: [],
            hotelList: [],
            addedHotels: [],
            voucherRebate: this.getNewVoucherRebate(),
            voucherConfig: {
                multiLingual: getMultiLangEmpty(),
                isPaymentMode: false,
                allowPartialRedeem: true,
                singleDayRedeem: false,
                validUntilUnit: 'Months'
            },
            voucherRebateList: [],
            voucherHotelList: [],
            voucherEmissionHotelList: [],
            voucherImageList: [],
            voucherTermsList: [],
            voucherChannelList: [],
            ReveneuCatList: [],
            templateImages: [],
            templateImage: null,
            vatModal: false
        }
    }

    getNewVoucherRebate() {
        const voucherRebate = {
            id: null,
            multiLingual: getMultiLangEmpty()
        };
        return voucherRebate;
    }

    componentDidMount() {
        if (this.props.match.params.id) {
            this.getConfigDetails(this.props.match.params.id)
        }
        else if (this.props.location.state?.voucherIdToCopy) {
            this.getConfigDetails(this.props.location.state.voucherIdToCopy, true)
        }
        else this.setState({ block: false });


        this.getHotels();
        this.getTerms();
        this.getChannels();
        this.getReveneuCategories();
    }

    next(val) {
        var stateCopy = Object.assign({}, this.state);
        stateCopy.steps = stateCopy.steps.slice();
        for (var i = 0; i < stateCopy.steps.length; i++) {
            if (stateCopy.steps[i].step === val) {
                stateCopy.steps[i] = Object.assign({}, stateCopy.steps[i]);
                stateCopy.steps[i].active = true;
                stateCopy.steps[i].enabled = true;
            }
            else {
                stateCopy.steps[i] = Object.assign({}, stateCopy.steps[i]);
                stateCopy.steps[i].active = false;
            }
        }
        this.setState(stateCopy);
    }


    getTerms() {
        this.setState({ blockCfg: true });
        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, blockCfg: false });

                return;
            }
            if (data) {
                data.response.forEach(processMultilingualTexts);
                this.setState({ termsList: data.response, blockCfg: false });
            }
        }, '/api/Voucher/v1/Config/getTermsAndConditions');
    }

    getChannels() {
        this.setState({ blockCfg: true });
        getAPI(result => {
            const { data, error } = result;
            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, blockCfg: false });
                return;
            }
            if (data) {

                this.setState({ channelList: data.response, blockCfg: false });
            }
        }, '/api/Voucher/v1/Config/getChannels');
    }

    getConfigDetails(id, isCopy) {
        this.setState({ block: true });
        getAPI(result => {
            const { data, error } = result;
            const errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState({ error: errorMessage, block: false });
                }
                else if (data.response && data.response.length > 0) {
                    const voucher = data.response[0];
                    processMultilingualTexts(voucher);
                    this.populateVoucherTerms(voucher.voucherTerms, voucher.id);
                    voucher.voucherImages.forEach((img, idx) => {
                        if (img.index === null) {
                            img.index = idx;
                        }
                    });
                    voucher.voucherRebates.forEach(processMultilingualTexts);

                    if (isCopy) {
                        delete voucher.id;
                        delete voucher.code;
                    }

                    this.setState({
                        voucherConfig: voucher,
                        voucherRebateList: voucher.voucherRebates,
                        voucherHotelList: voucher.validHotels || [],
                        voucherEmissionHotelList: voucher.creationValidHotels || [],
                        voucherImageList: voucher.voucherImages.sort((img1, img2) => img1.index - img2.index),
                        voucherTermsList: voucher.voucherTerms,
                        voucherChannelList: voucher.channels,
                        block: false
                    });
                }
                else {
                    this.setState({ error: errorMessage, block: false });
                }
            }
        }, '/api/Voucher/v1/Config/getVoucherType/' + id);
    }

    populateVoucherTerms(voucherTerms, voucherTypeId) {
        this.checkVoucherTerms(voucherTerms, "Included", voucherTypeId);
        this.checkVoucherTerms(voucherTerms, "Excluded", voucherTypeId);
    }

    checkVoucherTerms(voucherTerms, type, voucherTypeId) {
        const voucherTermsIncluded = voucherTerms
            .filter(term => term.type === type)
            .map(processMultilingualTexts);
        if (voucherTermsIncluded.length === 0) {
            voucherTerms.push({
                voucherTypeId: voucherTypeId,
                code: null,
                type: type,
                multiLingual: getMultiLangEmpty()
            });
        }
    }

    toggleTab(id) {
        this.setState({ activeTab: id });
    }

    toggleRebateModal = (rebate) => {
        this.setState(prevState => ({
            modal: !prevState.modal,
            selectedRebate: rebate
        }));
    }

    toggleModal(modal) {
        this.setState(prevState => ({
            [modal]: !prevState[modal]
        }));
    }

    toggleModalPreview() {
        this.setState(prevState => ({
            modalPreview: !prevState.modalPreview
        }));
    }

    handleSwitched(f, evt) {
        const name = evt.target.name;
        const value = evt.target.checked;

        if (name === 'allowPartialRedeem' && value === false) {
            this.setState(prevState => ({
                ...prevState,
                voucherConfig: {
                    ...prevState.voucherConfig,
                    allowPartialRedeem: value,
                    dailyValueLimit: null,
                    isRechargable: false
                }
            }));
        }
        else        
        {
            this.setState(prevState => ({
                ...prevState,
                [f]: {
                    ...prevState[f],
                    [name]: value
                }
            }));
        }
    }

    handleVoucherType = (evt) => {
        const value = evt.target.checked;
        const action = evt.target.checked ? getMonetaryVoucherActions(this.props.intl)[0].value : null;
        const isRechargable = evt.target.checked ? this.state.voucherConfig.isRechargable : false;
        const allowPartialRedeem = evt.target.checked ? this.state.voucherConfig.allowPartialRedeem : null;
        // Single day usage only applies to service vouchers.
        const singleDayRedeem = evt.target.checked ? false : this.state.voucherConfig.singleDayRedeem;

        this.setState(prevState => ({
            ...prevState,
            voucherConfig: {
                ...prevState.voucherConfig,
                isPaymentMode: value,
                action,
                isRechargable,
                allowPartialRedeem,
                singleDayRedeem
            },
        }));
    }

    handleCheck(evt) {
        let name = evt.target.name;
        let value = evt.target.checked;
        if (value === true) {
            this.setState({ addedHotels: [...this.state.addedHotels, name] });
        }
        else {
            this.setState({ addedHotels: [...this.state.addedHotels.filter(el => el !== name)] });
        }
    }

    handleDatesChange = (type, start, end) => {
        if (type === 'r') {
            this.setState(prevState => ({
                ...prevState,
                voucherRebate: {
                    ...prevState.voucherRebate,
                    saleValidTo: end,
                    saleValidFrom: start

                },
            }));
        } else {
            this.setState(prevState => ({
                ...prevState,
                voucherConfig: {
                    ...prevState.voucherConfig,
                    saleValidTo: end,
                    saleValidFrom: start

                },
            }));
        }
    }

    saveVoucher = (e) => {
        e.preventDefault();

        if (this.state.voucherConfig.isPaymentMode === false && this.state.voucherConfig.payedAmount > 0 &&
            (!this.state.voucherConfig.voucherTypeVat || this.state.voucherConfig.voucherTypeVat.reduce((acc, curr) => acc + parseFloat(curr.amount), 0).toFixed(2) !== parseFloat(this.state.voucherConfig.payedAmount).toFixed(2))) {
            handleNotification({ data: {} }, <FormattedMessage id="EditVoucher.SumOfVatAmountsMustBeEqualToPayedAmount" />, '', 'info');
            return;
        }

        // an active services voucher type must have at least one configured service (avoid backend VOUCFG0044);
        // a new/copied type (no id) never has services yet — save it inactive, add services, then activate
        if (this.state.voucherConfig.isPaymentMode === false && this.state.voucherConfig.active === true &&
            (!this.state.voucherConfig.id || (this.state.voucherRebateList || []).length === 0)) {
            handleNotification({ errors: [{ message: this.props.intl.formatMessage({ id: "CardConfigWizard.ActiveRequiresServices" }), code: "" }] });
            return;
        }

        this.setState({ block: true });

        let temp = this.state.voucherConfig;
        delete temp['validHotels'];
        delete temp['creationValidHotels'];
        delete temp['voucherRebates'];
        if (temp.id === undefined)
            temp.id = null

        if (this.state.voucherConfig.tec) {
            temp.termsConditionsId = this.state.voucherConfig.tec.id;
        }

        if (!this.state.voucherConfig.isPaymentMode) {
            temp.allowPartialRedeem = null;
        }
        else if (temp.allowPartialRedeem === null) {
            temp.allowPartialRedeem = false;
        }


        let payload = { request: temp };


        this.setState({ block: true });
        postAPI(result => {
            const { data, error } = result;
            const errorMessage = [];
            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState(({ block: false, error: errorMessage }));
                    return;
                }
                if (data.response && data.response.length > 0) {
                    const voucherTermsList = [...this.state.voucherTermsList];
                    if (voucherTermsList.length === 0) {
                        this.populateVoucherTerms(voucherTermsList, data.response[0].id);
                        this.setState({ voucherTermsList });
                    }
                    this.props.history.push({ pathname: `/CardConfigWizard/${data.response[0].id}` });
                    handleNotification(data, <FormattedMessage id="CardConfigWizard.ConfigSaved" />, <FormattedMessage id="generic.success" />);

                    const amountLangs = !temp.isPaymentMode ? getCardAmountTagLanguages(temp.subjectTranslations) : [];
                    if (amountLangs.length > 0) {
                        handleNotification(
                            { warnings: [{ message: <FormattedMessage id="CardConfigWizard.SubjectAmountInNonMonetaryToast" values={{ langs: amountLangs.join(', '), tag: '{{CardAmount}}' }} /> }] }
                        );
                    }

                    const giftAmountLangs = !temp.isPaymentMode ? getCardAmountTagLanguages(temp.subjectGiftTranslations) : [];
                    if (giftAmountLangs.length > 0) {
                        handleNotification(
                            { warnings: [{ message: <FormattedMessage id="CardConfigWizard.SubjectGiftAmountInNonMonetaryToast" values={{ langs: giftAmountLangs.join(', '), tag: '{{CardAmount}}' }} /> }] }
                        );
                    }

                    const voucherConfig = data.response[0];
                    voucherConfig.multiLingual = Object.assign(voucherConfig.multiLingual, temp.multiLingual);

                    this.setState({ voucherConfig }, this.getConfigDetails(data.response[0].id));
                }
                else {
                    this.setState({ error: errorMessage, block: false });
                }
            }
            else {
                this.setState({ error: errorMessage, block: false });
            }
        }, '/api/Voucher/v1/Config/setVoucherType', payload);
    }

    saveRebate = (e, rebate) => {
        e.preventDefault();

        this.setState({ block: true });
        let temp = rebate;

        if (temp.id === undefined) {
            temp.id = null;
        }

        temp.voucherTypeId = this.state.voucherConfig.id;

        const payload = { request: temp };

        postAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                handleNotification(data, <FormattedMessage id="EditVoucher.RebateAdded" />, <FormattedMessage id="EditVoucher.Success" />);

                this.setState({ block: false }, () => {
                    this.toggleRebateModal();
                    this.getConfigDetails(this.state.voucherConfig.id)
                });
            }
        }, '/api/Voucher/Voucher/v1/voucherrebate', payload);
    }

    removeRebate(id) {
        this.setState({ block: true });

        deleteAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                handleNotification(data, <FormattedMessage id="EditVoucher.RebateRemoved" />, <FormattedMessage id="EditVoucher.Success" />);

                this.setState({ block: false }, () => this.getConfigDetails(this.state.voucherConfig.id));
            }
        }, '/api/Voucher/Voucher/v1/voucherrebate/' + id);

    }

    getHotels() {
        this.setState({ block: true });
        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {

                this.setState({ hotelList: data.response[0], block: false });
            }
        }, '/api/Voucher/Hotel/v1/hotel');

    }

    updateForm = (f, evt) => {
        let name = evt.target.name;
        let value = evt.target.value;

        this.setState(prevState => ({
            ...prevState,
            [f]: {
                ...prevState[f],
                [name]: value
            },
        })/*, () => this.updateTemplateImages()*/);
    }

    updateVoucherValidUnit = (combo) => {
        let vouchersValidUntil = this.state.voucherConfig.vouchersValidUntil;
        let validUntilFixedDate = this.state.voucherConfig.validUntilFixedDate;

        if (combo.value === 'FixedDate') {
            vouchersValidUntil = null;
        }
        else {
            validUntilFixedDate = null;
        }

        this.setState(prevState => ({
            ...prevState,
            voucherConfig: {
                ...prevState.voucherConfig,
                validUntilUnit: combo.value,
                vouchersValidUntil,
                validUntilFixedDate
            },
        }));
    }

    updateComboForm(f, val, evt) {
        if (evt != undefined) {
            let name = evt.name;
            let value = val ? val.value : null;

            this.setState(prevState => ({
                ...prevState,
                [f]: {
                    ...prevState[f],
                    [name]: value

                },
            }));
        }
    }

    manageHotel(hotelId, evt) {
        const checked = evt.target.checked;

        this.setState(prevState => {
            let voucherHotelList = prevState.voucherHotelList ? [...prevState.voucherHotelList] : [];

            if (checked) {
                if (!voucherHotelList.some(x => x.guid === hotelId)) {
                    voucherHotelList.push({ guid: hotelId });
                }
            }
            else {
                voucherHotelList = voucherHotelList.filter(x => x.guid !== hotelId);
            }

            return { voucherHotelList };
        });
    }

    saveValidHotels() {
        const hotels = (this.state.voucherHotelList || []).map(x => x.guid);

        this.setState({ block: true });

        const payload = {
            "request": {
                "id": this.state.voucherConfig.id,
                "hotels": hotels
            }
        };

        putAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState({ block: false });

                    return;
                }
                handleNotification(data, <FormattedMessage id="CardConfigWizard.ConfigSaved" />, <FormattedMessage id="generic.success" />);
                this.setState({ voucherHotelList: data.response && data.response[0] ? data.response[0].hotels : this.state.voucherHotelList, block: false });
            }
        }, '/api/Voucher/Voucher/v1/vouchervalidity', payload);
    }

    manageEmissionHotel(hotelId, evt) {
        const checked = evt.target.checked;

        this.setState(prevState => {
            let voucherEmissionHotelList = prevState.voucherEmissionHotelList ? [...prevState.voucherEmissionHotelList] : [];

            if (checked) {
                if (!voucherEmissionHotelList.some(x => x.guid === hotelId)) {
                    voucherEmissionHotelList.push({ guid: hotelId });
                }
            }
            else {
                voucherEmissionHotelList = voucherEmissionHotelList.filter(x => x.guid !== hotelId);
            }

            return { voucherEmissionHotelList };
        });
    }

    saveEmissionHotels() {
        const hotels = (this.state.voucherEmissionHotelList || []).map(x => x.guid);

        // a voucher type must have at least one emission hotel (avoid backend VOUCFG0043)
        if (hotels.length === 0) {
            handleNotification({ errors: [{ message: this.props.intl.formatMessage({ id: "CardConfigWizard.EmissionHotelsRequired" }), code: "" }] });
            return;
        }

        this.setState({ block: true });

        const payload = {
            "request": {
                "id": this.state.voucherConfig.id,
                "hotels": hotels
            }
        };

        putAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState({ block: false });

                    return;
                }
                handleNotification(data, <FormattedMessage id="CardConfigWizard.ConfigSaved" />, <FormattedMessage id="generic.success" />);
                this.setState({ voucherEmissionHotelList: data.response && data.response[0] ? data.response[0].hotels : this.state.voucherEmissionHotelList, block: false });
            }
        }, '/api/Voucher/Voucher/v1/voucheremissionvalidity', payload);
    }

    toggleAllHotels(listKey, select) {
        const hotels = (this.state.hotelList && this.state.hotelList.hotels) || [];
        this.setState({ [listKey]: select ? hotels.map(h => ({ guid: h.hotelId })) : [] });
    }

    renderHotelValidityCard({ icon, titleId, listKey, onToggle, onSave, namePrefix, emptyWarningId, canEditVoucher }) {
        const hotels = (this.state.hotelList && this.state.hotelList.hotels) || [];
        const list = this.state[listKey] || [];
        const total = hotels.length;
        const selected = list.length;
        const allSelected = total > 0 && selected === total;

        return (
            <BlankCard block={this.state.block}>
                <Row className="align-items-center mb-1">
                    <Col className="d-flex align-items-center">
                        <i className={`${icon} color-host mr-2`} />
                        <h5 className="mb-0"><FormattedMessage id={titleId} /></h5>
                        {emptyWarningId && selected === 0 &&
                            <>
                                <i id={`${listKey}Warning`} className="fa-solid fa-triangle-exclamation ml-2 text-warning" style={{ cursor: 'help' }} />
                                <UncontrolledTooltip placement="top" target={`${listKey}Warning`}>
                                    <FormattedMessage id={emptyWarningId} />
                                </UncontrolledTooltip>
                            </>
                        }
                    </Col>
                    <Col className="col-auto text-right">
                        {canEditVoucher &&
                            <>
                                <Button id={`${listKey}Save`} className="btn-host btn-sm" onClick={onSave}>
                                    <i className="fa-solid fa-save" />
                                </Button>
                                <UncontrolledTooltip placement="top" target={`${listKey}Save`}>
                                    <FormattedMessage id="CardConfigWizard.SaveValidHotels" />
                                </UncontrolledTooltip>
                            </>
                        }
                    </Col>
                </Row>
                <hr className="my-1 border-host" />
                {canEditVoucher && total > 0 &&
                    <div className="text-right mb-2">
                        <Button color="link" className="p-0 font_size_xxs color-host" onClick={() => this.toggleAllHotels(listKey, !allSelected)}>
                            <i className={`fa-solid ${allSelected ? 'fa-eraser' : 'fa-check-double'} mr-1`} />
                            <FormattedMessage id={allSelected ? "CardConfigWizard.ClearAll" : "CardConfigWizard.SelectAll"} />
                        </Button>
                    </div>
                }
                <div className="rounded hotel-list-box">
                    {hotels.map((item, k) => {
                        const isSelected = list.some(x => x.guid === item.hotelId);
                        return (
                            <div key={k}
                                className={`px-2 py-2 overbglight toggle-row${canEditVoucher ? ' editable' : ''}`}
                                onClick={canEditVoucher ? (e) => { if (!e.target.closest('.custom-control')) onToggle.call(this, item.hotelId, { target: { checked: !isSelected } }); } : undefined}>
                                <span className="d-inline-block">
                                    <CustomInput
                                        type="switch"
                                        label={item.name2}
                                        checked={isSelected}
                                        name={namePrefix + k} id={namePrefix + k}
                                        onChange={onToggle.bind(this, item.hotelId)}
                                        disabled={!canEditVoucher}
                                    />
                                </span>
                            </div>
                        );
                    })}
                </div>
            </BlankCard>
        );
    }

    getFilteredHotels() {
        let res = [];
        if (this.state.hotelList.hotels) {
            res = this.state.hotelList.hotels.filter(el => this.state.voucherHotelList.find(item => item.guid === el.hotelId) === undefined);
        }
        return res === undefined ? [] : res;
    }

    handleDropTEC = (e) => {
        if (e.types.includes('tec')) {
            let evtData = JSON.parse(e.getData('TEC'));
            let req = {
                request: {
                    id: this.state.voucherConfig.id,
                    termsConditionsId: evtData.id
                }
            }

            postAPI(result => {
                const { data, error } = result;

                if (error) {
                    var errorMessage = [];
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });

                    return;
                }
                if (data) {
                    handleNotification(data, <FormattedMessage id="EditVoucher.TermsAndConditionsUpdated" />, <FormattedMessage id="EditVoucher.Success" />);
                    this.setState(prevState => ({
                        block: false,
                        ...prevState,
                        voucherConfig: {
                            ...prevState.voucherConfig,
                            tec: evtData

                        },
                    }));
                }
            }, '/api/Voucher/v1/Config/setVoucherTypeOnlineProp', req);
        }
    }

    manageChannel(id, ciid, evt) {
        this.setState({ block: true });
        if (evt.target.checked) {
            postAPI(result => {
                const { data, error } = result;

                if (error) {
                    var errorMessage = [];
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });

                    return;
                }
                if (data) {
                    handleNotification(data, <FormattedMessage id="EditVoucher.ChannelAdded" />, <FormattedMessage id="EditVoucher.Success" />);
                    this.setState(prevState => ({ block: false, voucherChannelList: [...prevState.voucherChannelList.filter(el => el.id !== data.response[0].id), data.response[0]] }));
                }
            }, '/api/Voucher/v1/Config/addChannelInstance/' + this.state.voucherConfig.id + '/' + id);
        } else {
            deleteAPI(result => {
                const { data, error } = result;

                if (error) {
                    var errorMessage = [];
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });

                    return;
                }
                if (data) {
                    handleNotification(data, <FormattedMessage id="EditVoucher.ChannelRemoved" />, <FormattedMessage id="EditVoucher.Success" />);
                    this.setState(prevState => ({ block: false, voucherChannelList: [...prevState.voucherChannelList.filter(el => el.id !== data.response[0].id)] }));
                }
            }, '/api/Voucher/v1/Config/removeChannelInstance/' + ciid);
        }

    }

    changeTerms(type, evt) {

        let t = type;
        let value = evt.target.value;

        this.setState(prevState => ({
            block: false,
            ...prevState,
            voucherTermsList:
                [...prevState.voucherTermsList.filter(el => el.type !== type),
                { description: value, type: t, voucherTypeId: this.state.voucherConfig.id }

                ]

        }
        ));
    }

    saveTerms(type, evt) {
        const req = { request: this.state.voucherTermsList.find(el => el.type === type) };
        this.setState({ block: true });
        postAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                handleNotification(data, <FormattedMessage id="EditVoucher.TermsSaved" />, <FormattedMessage id="EditVoucher.Success" />);
                this.setState({ block: false });
            }
        }, '/api/Voucher/v1/Config/addVoucherTypeTerms', req);
    }

    getReveneuCategories() {
        this.setState({ block: true });
        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {

                let arr = [];

                data.response.map(el => arr.push({ label: el.description, value: el.id }));

                this.setState({ ReveneuCatList: arr, block: false });
            }
        }, '/api/Voucher/v1/Config/ReveneuCategories');

    }

    savePromote() {
        this.setState({ block: true });
        let req = {
            "request": {
                "id": this.state.voucherConfig.id,
                "promote": this.state.voucherConfig.promote,
                "promoteType": this.state.voucherConfig.promoteType,
                "promoCode": this.state.voucherConfig.promoCode || null
            }
        }


        postAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                handleNotification(data, <FormattedMessage id="EditVoucher.PromotionConditionsUpdated" />, <FormattedMessage id="EditVoucher.Success" />);
                this.setState({ block: false });
            }
        }, '/api/Voucher/v1/Config/setVoucherTypeOnlineProp', req);


    }

    udpateText = (evt, lang) => {
        const multiLingual = [...this.state.voucherConfig.multiLingual];
        const idx = multiLingual.indexOf(multiLingual.find(ml => ml.languageCode === lang));

        if (idx >= 0) {
            const ml = multiLingual[idx];
            ml[evt.target && evt.target.name] = evt.target && evt.target.value;
            this.setState(prevState => ({
                ...prevState,
                voucherConfig: {
                    ...prevState.voucherConfig,
                    multiLingual: multiLingual
                }
            }));
        }
    }


    updateIncludedTerm(evt, lang) {
        this.updateTerm(evt, lang, "Included");
    }

    updateExcludedTerm(evt, lang) {
        this.updateTerm(evt, lang, "Excluded");
    }

    updateTerm(evt, lang, type) {
        const voucherTermsList = [...this.state.voucherTermsList];
        const voucherTerm = voucherTermsList.find(term => term.type === type);
        const multiLingual = voucherTerm && voucherTerm.multiLingual;
        const idx = multiLingual && multiLingual.indexOf(multiLingual.find(ml => ml.languageCode === lang));
        if (idx >= 0) {
            const ml = multiLingual[idx];
            ml[evt.target && evt.target.name] = evt.target && evt.target.value;
            this.setState(({ voucherTermsList }));
        }
    }


    handleVoucherTypeVat = (evt, vat) => {
        evt.preventDefault();
        const voucher = { ...this.state.voucherConfig };
        let vatList = voucher.voucherTypeVat ? voucher.voucherTypeVat : []

        if (vat) {
            vatList = vatList.filter(v => v !== vat);
        }
        else {
            vatList.push({ taxCode: this.state.vatTaxCode, amount: this.state.vatAmount });
        }

        voucher.voucherTypeVat = vatList;

        this.setState({ voucherConfig: voucher }, () => { if (!vat) this.toggleModal('vatModal') });
    }

    updateImageList = (list) => {
        this.setState({ voucherImageList: list });
    }

    render() {
        function getTerm(voucherTermsList, type) {
            const term = voucherTermsList && voucherTermsList.find(term => term.type === type);
            return term ? term.multiLingual : []
        }

        function getTecMultilingual(termsList, tec) {
            const term = termsList && tec && termsList.find(term => term.id === tec.id);
            return term ? term.multiLingual : []
        }

        const taxCodes = getTaxCodes();
        const canEditVoucher = this.state.voucherConfig?.adminRestricted ? CheckAuthorization("adminRestrictedVoucher:edit") : true;


        return (
            <>
                <Modal isOpen={this.state.modalPreview} toggle={this.toggleModalPreview} fade={false} className="modal-xl" >
                    <ModalBody className="modal-xl p-0">
                        <VoucherPreview
                            voucherConfig={this.state.voucherConfig}
                            voucherRebateList={this.state.voucherRebateList}
                            voucherHotelList={this.state.voucherHotelList}
                            voucherImageList={this.state.voucherImageList}
                            voucherTermsList={this.state.voucherTermsList}
                            intl={this.props.intl}
                        />
                    </ModalBody>
                </Modal>

                {this.state.modal ?
                    <RebateModal
                        modal={this.state.modal}
                        toggleRebateModal={this.toggleRebateModal}
                        selectedRebate={this.state.selectedRebate}
                        saveRebate={this.saveRebate}
                        intl={this.props.intl}
                        ReveneuCatList={this.state.ReveneuCatList}
                        error={this.state.error}
                        block={this.state.block}
                    />
                : ''}
                
                <Modal isOpen={this.state.vatModal} toggle={() => this.toggleModal('vatModal')} fade={false} className="modal-xl" >
                    <ModalHeader toggle={() => this.toggleModal('vatModal')} className="py-2">
                        <FormattedMessage id="EditVoucher.AddRebate" />
                    </ModalHeader>
                    <ModalBody className="modal-xl">
                        <Form onSubmit={(e) => this.handleVoucherTypeVat(e)}>
                            <Row className="mb-2">
                                <Col className="text-right">
                                    <Button className="btn-host btn-sm" type="submit"> <i className="fa-solid fa-floppy-disk " /></Button>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col className="col-2">
                                    <Label><FormattedMessage id="EditVoucher.TaxCode" /></Label>
                                </Col>
                                <Col className="col-4">
                                    <CustomSelect required
                                        options={this.state.voucherConfig.voucherTypeVat ? taxCodes.filter(tc => this.state.voucherConfig.voucherTypeVat.some(el => el.taxCode === tc.value) === false) : taxCodes}
                                        onChange={(combo) => this.setState({ vatTaxCode: combo ? combo.value : null })}
                                        placeholder={<FormattedMessage id="EditVoucher.TaxCode" />}
                                    />
                                </Col>
                                <Col className="col-2">
                                    <Label><FormattedMessage id="EditVoucher.Amount" /></Label>
                                </Col>
                                <Col className="col-4">
                                    <FormattedMessage id="EditVoucher.Amount" >
                                        {placeholder =>
                                            <Input type="number" min="1" step=".01"
                                                required placeholder={placeholder}
                                                onChange={(e) => this.setState({ vatAmount: e.target.value })}
                                            />
                                        }
                                    </FormattedMessage>
                                </Col>
                            </Row>
                        </Form>
                    </ModalBody>
                </Modal>

                <Row className="align-items-center">
                    <Col className="py-1 align-middle">
                        <Badge tag="button" style={{ minWidth: '100px' }} className={'btn align-middle mr-2 py-2 border ' + (this.state.steps && this.state.steps[0].active === true ? 'btn-host' : 'bg-light text-secondary') + (this.state.steps && this.state.steps[0].enabled === true ? ' ' : ' disabled ')} onClick={() => this.next('1')}>
                            <div className="mb-1">
                                <FormattedMessage id="CardConfigWizard.Step1" />
                            </div>
                            <div>
                                <FormattedMessage id="CardConfigWizard.Card" />
                            </div>
                        </Badge>
                        <i className="fa-solid fa-chevron-right fa-2x text-secondary align-middle mr-2 "></i>
                        <Badge tag="button" style={{ minWidth: '100px' }} className={'btn align-middle mr-2 py-2 border ' + (this.state.steps && this.state.steps[1].active === true ? 'btn-host' : 'bg-light text-secondary') + (this.state.steps && this.state.steps[1].enabled === true ? ' ' : ' disabled ')} disabled={this.state.voucherConfig.isPaymentMode === false && this.state.voucherConfig.id ? false : true} onClick={() => this.next('2')} >
                            <div className="mb-1">
                                <FormattedMessage id="CardConfigWizard.Step2" />
                            </div>
                            <div>
                                <FormattedMessage id="CardConfigWizard.Rebates" />
                            </div>
                        </Badge>
                        <i className="fa-solid fa-chevron-right fa-2x text-secondary align-middle mr-2  "></i>
                        <Badge tag="button" style={{ minWidth: '100px' }} className={'btn align-middle mr-2 py-2 border ' + (this.state.steps && this.state.steps[2].active === true ? 'btn-host' : 'bg-light text-secondary') + (this.state.steps && this.state.steps[2].enabled === true ? ' ' : ' disabled ')} disabled={!this.state.voucherConfig.id ? true : false} onClick={() => this.next('3')} >
                            <div className="mb-1">
                                <FormattedMessage id="CardConfigWizard.Step3" />
                            </div>
                            <div>
                                <FormattedMessage id="CardConfigWizard.PointOfSales" />
                            </div>
                        </Badge>
                        <i className="fa-solid fa-chevron-right fa-2x text-secondary align-middle mr-2  "></i>
                        <Badge tag="button" style={{ minWidth: '100px' }} className={'btn align-middle mr-2 py-2 border ' + (this.state.steps && this.state.steps[3].active === true ? 'btn-host' : 'bg-light text-secondary') + (this.state.steps && this.state.steps[3].enabled === true ? ' ' : ' disabled ')} disabled={!this.state.voucherConfig.id ? true : false} onClick={() => this.next('4')} >
                            <div className="mb-1">
                                <FormattedMessage id="CardConfigWizard.Step4" />
                            </div>
                            <div>
                                <FormattedMessage id="CardConfigWizard.TermsConditions" />
                            </div>
                        </Badge>
                        <i className="fa-solid fa-chevron-right fa-2x text-secondary align-middle mr-2  "></i>
                        <Badge tag="button" style={{ minWidth: '100px' }} className={'btn align-middle mr-2 py-2 border ' + (this.state.steps && this.state.steps[4].active === true ? 'btn-host' : 'bg-light text-secondary') + (this.state.steps && this.state.steps[4].enabled === true ? ' ' : ' disabled ')} disabled={!this.state.voucherConfig.id ? true : false} onClick={() => this.next('5')} >
                            <div className="mb-1">
                                <FormattedMessage id="CardConfigWizard.Step5" />
                            </div>
                            <div>
                                <FormattedMessage id="CardConfigWizard.Includions" />
                            </div>
                        </Badge>
                        <i className="fa-solid fa-chevron-right fa-2x text-secondary align-middle mr-2  "></i>
                        <Badge tag="button" style={{ minWidth: '100px' }} className={'btn align-middle mr-2 py-2 border ' + (this.state.steps && this.state.steps[5].active === true ? 'btn-host' : 'bg-light text-secondary') + (this.state.steps && this.state.steps[4].enabled === true ? ' ' : ' disabled ')} disabled={!this.state.voucherConfig.id ? true : false} onClick={() => this.next('6')} >
                            <div className="mb-1">
                                <FormattedMessage id="CardConfigWizard.Step6" />
                            </div>
                            <div>
                                <FormattedMessage id="CardConfigWizard.Images" />
                            </div>
                        </Badge>
                        <i className="fa-solid fa-chevron-right fa-2x text-secondary align-middle mr-2  "></i>
                        <Badge tag="button" style={{ minWidth: '100px' }} className={'btn align-middle mr-2 py-2 border ' + (this.state.steps && this.state.steps[6].active === true ? 'btn-host' : 'bg-light text-secondary') + (this.state.steps && this.state.steps[5].enabled === true ? ' ' : ' disabled ')} disabled={!this.state.voucherConfig.id ? true : false} onClick={() => this.next('7')}>
                            <div className="mb-1">
                                <FormattedMessage id="CardConfigWizard.Step7" />
                            </div>
                            <div>
                                <FormattedMessage id="CardConfigWizard.Promote" />
                            </div>
                        </Badge>
                        <i className="fa-solid fa-chevron-right fa-2x text-secondary align-middle mr-2  "></i>
                        <Badge tag="button" style={{ minWidth: '100px' }} className={'btn align-middle mr-2 py-2 border ' + (this.state.steps && this.state.steps[7].active === true ? 'btn-host' : 'bg-light text-secondary') + (this.state.steps && this.state.steps[6].enabled === true ? ' ' : ' disabled ')} disabled={!this.state.voucherConfig.id ? true : false} onClick={() => this.next('8')}>
                            <div className="mb-1">
                                <FormattedMessage id="CardConfigWizard.Step8" />
                            </div>
                            <div>
                                <FormattedMessage id="CardConfigWizard.Template" />
                            </div>
                        </Badge>
                    </Col>
                    <Col className="col-1 text-right">
                        {/* This preview builds the v1 iframe snippet. Units on the WidgetV2
                            module configure the widget in Configurations > Widget instead. */}
                        {global.license && global.license.modules && global.license.modules.includes('WidgetV2') ?
                            ''
                            :
                            <Button className="btn-host btn-sm mr-1" onClick={this.toggleModalPreview} disabled={this.state.voucherChannelList && this.state.voucherChannelList.find(el => el.name === 'Online') === undefined}>
                                <i className="fa-regular fa-eye" />
                            </Button>
                        }
                    </Col>
                </Row>
                <div className="mb-2"></div>
                <Card className="border-0" style={{ display: (this.state.steps && this.state.steps[0].active === true ? 'block' : 'none'), height: '100%' }}>
                    <VoucherConfigStep1
                        block={this.state.block}
                        saveVoucher={this.saveVoucher}
                        voucherConfig={this.state.voucherConfig}
                        updateForm={this.updateForm}
                        updateVoucherValidUnit={this.updateVoucherValidUnit}
                        handleDatesChange={this.handleDatesChange}
                        udpateText={this.udpateText}
                        handleSwitched={this.handleSwitched}
                        toggleModal={this.toggleModal}
                        handleVoucherTypeVat={this.handleVoucherTypeVat}
                        taxCodes={taxCodes}
                        updateComboForm={this.updateComboForm.bind(this, 'voucherConfig')}
                        handleVoucherType={this.handleVoucherType}
                        canEditVoucher={canEditVoucher}
                    />
                </Card>


                <Card className="border-0" style={{ display: (this.state.steps && this.state.steps[1].active === true ? 'block' : 'none'), height: '100%' }}>

                    <BlankCard title='EditVoucher.Rebates' block={this.state.block} >
                        <Row>
                            <Col>
                                <h5><FormattedMessage id="EditVoucher.Rebates" /></h5>
                            </Col>
                            <Col className="text-right">
                                {canEditVoucher && 
                                    <Authorization
                                        perform="cardConfigWizard:addService"
                                        yes={() => (
                                            <Button className="btn-host btn-sm" onClick={() => this.toggleRebateModal(this.getNewVoucherRebate())} disabled={this.state.voucherConfig.id === undefined ? true : false}>
                                                <i className="fa-solid fa-plus " />
                                            </Button>
                                        )}
                                        no={() => <div></div>}
                                    />
                                }
                            </Col>
                        </Row>
                        <hr className="my-1 border-host" />
                        <Row className="mt-2">
                            {
                                this.state.voucherRebateList && this.state.voucherRebateList.map((item, k) =>
                                    <Col className="col-3" key={k}>
                                        <Card>
                                            <CardBody className="pt-2">
                                                <Row className="mb-2">
                                                    <Col className="col-1" />
                                                    <Col className="text-center pr-0"><b>{item.code}</b></Col>
                                                    {canEditVoucher &&
                                                        <Col className="col-3 text-right">
                                                            <span style={{ cursor: 'pointer' }} className="mr-1" onClick={() => this.toggleRebateModal(item)}>
                                                                <i className="fa-solid fa-pen-to-square color-host" />
                                                            </span>

                                                            <Authorization
                                                                perform="cardConfigWizard:removeService"
                                                                yes={() => (
                                                                    <span style={{ cursor: 'pointer' }}>
                                                                        <i className="fa-solid fa-xmark color-host ml-1" onClick={this.removeRebate.bind(this, item.id)} />
                                                                    </span>
                                                                )}
                                                                no={() => <div></div>}
                                                            />
                                                        </Col>
                                                    }
                                                </Row>
                                                <Row className="mb-4">
                                                    <Col>
                                                        <MultiLangText key={k} textList={item.multiLingual} renderInCard={true} />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className=""><b><FormattedMessage id="EditVoucher.Quantity" /> </b></Col>
                                                    <Col className="text-right"><b><FormattedMessage id="CardConfigWizard.Action" /> </b></Col>
                                                </Row>
                                                <Row>
                                                    <Col className="">{item.quantity}</Col>
                                                    <Col className="text-right"><FormattedMessage id={`ReferenceDataFunctions.${item.action}`} /></Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                )
                            }
                        </Row>
                    </BlankCard>
                </Card>
                <Card className="border-0" style={{ display: (this.state.steps && this.state.steps[2].active === true ? 'block' : 'none'), height: '100%' }}>
                    <Row>
                        <Col>
                            {this.renderHotelValidityCard({
                                icon: 'fa-solid fa-cart-shopping',
                                titleId: 'CardConfigWizard.EmissionValidHotels',
                                listKey: 'voucherEmissionHotelList',
                                onToggle: this.manageEmissionHotel,
                                onSave: this.saveEmissionHotels.bind(this),
                                namePrefix: 'emissionhotelid',
                                canEditVoucher
                            })}
                        </Col>
                        <Col>
                            {this.renderHotelValidityCard({
                                icon: 'fa-solid fa-wallet',
                                titleId: 'CardConfigWizard.RedeemValidHotels',
                                listKey: 'voucherHotelList',
                                onToggle: this.manageHotel,
                                onSave: this.saveValidHotels.bind(this),
                                namePrefix: 'redeemhotelid',
                                emptyWarningId: 'CardConfigWizard.NoRedeemHotelsWarning',
                                canEditVoucher
                            })}
                        </Col>
                        <Col sm={6} /*sm={12} className="mt-2"*/>
                            <BlankCard block={this.state.block} >
                                <Row >
                                    <Col>
                                        <h5><FormattedMessage id="CardConfigWizard.SalesChannels" /></h5>
                                    </Col>
                                    <Col className="text-right">
                                    </Col>
                                </Row>
                                <hr className="my-1 border-host" />
                                <Row className="mb-2">
                                    <Col>                                    
                                        {this.state.channelList && this.state.channelList.map((el, k) => {
                                            let chan = this.state.voucherChannelList && this.state.voucherChannelList.find(pos => pos.channelConfigId === el.id);
                                            const isChecked = chan !== undefined;
                                            return (
                                                <div key={k}
                                                    className={`px-2 py-2 overbglight toggle-row${canEditVoucher ? ' editable' : ''}`}
                                                    onClick={canEditVoucher ? (e) => { if (!e.target.closest('.custom-control')) this.manageChannel(el.id, chan && chan.id, { target: { checked: !isChecked } }); } : undefined}>
                                                    <span className="d-inline-block">
                                                        <CustomInput
                                                            checked={isChecked}
                                                            type="switch"
                                                            label={el.name}
                                                            id={'channel' + k}
                                                            onChange={this.manageChannel.bind(this, el.id, chan && chan.id)}
                                                            disabled={!canEditVoucher}
                                                        />
                                                    </span>
                                                </div>
                                            )
                                        })
                                        }

                                    </Col>
                                </Row>
                            </BlankCard>
                        </Col>
                    </Row>

                </Card>
                <Card className="border-0 " style={{ display: (this.state.steps && this.state.steps[3].active === true ? 'block' : 'none'), height: '100%' }}>
                    <BlankCard block={this.state.block} >
                        <Row className="mt-2 ">
                            <Col>
                                <h5><FormattedMessage id="CardConfigWizard.TermsConditions" /></h5>
                            </Col>
                        </Row>
                        <hr className="my-1 border-host" />

                        <Row className="my-2">
                            {this.state.voucherConfig.sold < 1 ?
                                <Col><h6><FormattedMessage id="EditVoucher.Selected" /> </h6>
                                    <hr className="my-1" />
                                </Col>
                                : ''}
                            <Col><h6><FormattedMessage id="EditVoucher.TermsAndConditions" /></h6>
                                <hr className="my-1" />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col className=" p-0">
                                {canEditVoucher && CheckAuthorization("cardConfigWizard:saveTEC") && this.state.voucherConfig.sold < 1 ?
                                    <DragAndDrop handleDrop={this.handleDropTEC} divStyle={{ display: 'inline-block', position: 'absolute', top: '0', left: '6px', width: '98%', height: '35%' }}>
                                        <div className="p-2" style={{ height: 100, minWidth: 300, whiteSpace: 'break-spaces' }}>
                                            <div>
                                                <MultiLangText textList={getTecMultilingual(this.state.termsList, this.state.voucherConfig.tec)} />
                                            </div>

                                        </div>
                                    </DragAndDrop>
                                    :
                                    <div className="py-2 px-3">
                                        <MultiLangText textList={getTecMultilingual(this.state.termsList, this.state.voucherConfig.tec)} renderInCard={true} />
                                    </div>
                                }
                            </Col>
                            {this.state.voucherConfig.sold < 1 ?
                                <Col className="col-6">
                                    {
                                        this.state.termsList && this.state.termsList.map((el, k) =>
                                            <Row className="mb-1" key={k}>
                                                <Col>
                                                    <Card>
                                                        <CardBody style={{ whiteSpace: 'break-spaces' }} draggable="true" onDragStart={(event) => event.dataTransfer.setData("TEC", JSON.stringify(el))} >
                                                            {el.code}
                                                            <MultiLangText key={k} textList={el.multiLingual} />
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        )
                                    }
                                </Col>
                                : ''}
                        </Row>
                    </BlankCard>
                </Card>
                <Card className="border-0" style={{ display: (this.state.steps && this.state.steps[4].active === true ? 'block' : 'none'), height: '100%' }}>
                    <BlankCard block={this.state.block} >
                        <Row>
                            <Col>
                                <h5><FormattedMessage id="EditVoucher.WhatsIncluded" /></h5>
                            </Col>
                            <Col className="text-right">
                            </Col>
                        </Row>
                        <hr className="my-1 border-host" />
                        <Row className="mb-2 align-items-center">
                            <Col className="col-5">
                                <i className="fa-solid fa-check text-success" /> <FormattedMessage id="EditVoucher.Included" /> 
                            </Col>
                            <Col className="text-right">
                                {canEditVoucher &&
                                    <Authorization
                                        perform="cardConfigWizard:saveTermsIncluded"
                                        yes={() => (
                                            <Button className="btn-host btn-sm" onClick={this.saveTerms.bind(this, 'Included')}>
                                                <i className="fa-solid fa-floppy-disk" />
                                            </Button>
                                        )}
                                        no={() => <div></div>}
                                    />
                                }
                            </Col>
                            <Col className="col-5">
                                <i className="fa-solid fa-xmark text-danger" /> <FormattedMessage id="EditVoucher.NotIncluded" />
                            </Col>
                            <Col className="text-right">
                                {canEditVoucher && 
                                    <Authorization
                                        perform="cardConfigWizard:saveTermsExcluded"
                                        yes={() => (
                                            <Button className="btn-host btn-sm" onClick={this.saveTerms.bind(this, 'Excluded')}>
                                                <i className="fa-solid fa-floppy-disk" />
                                            </Button>
                                        )}
                                        no={() => <div></div>}
                                    />
                                }
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <MultiLangText textList={getTerm(this.state.voucherTermsList, "Included")} udpateTerms={this.updateIncludedTerm.bind(this)} />
                            </Col>
                            <Col>
                                <MultiLangText textList={getTerm(this.state.voucherTermsList, "Excluded")} udpateTerms={this.updateExcludedTerm.bind(this)} />
                            </Col>
                        </Row>
                    </BlankCard>
                </Card>
                <Card className="border-0" style={{ display: (this.state.steps && this.state.steps[5].active === true ? 'block' : 'none'), height: '100%' }}>
                    <VoucherConfigStepImages
                        block={this.state.block}
                        canEditVoucher={canEditVoucher}
                        voucherImageList={this.state.voucherImageList}
                        updateImageList={this.updateImageList}
                        voucherConfigId={this.state.voucherConfig.id}
                    />
                </Card>
                <Card className="border-0" style={{ display: (this.state.steps && this.state.steps[6].active === true ? 'block' : 'none'), height: '100%' }}>
                    <BlankCard block={this.state.block} >
                        <Row className="mt-2 ">
                            <Col>
                                <h5><FormattedMessage id="EditVoucher.Promote" /></h5>
                            </Col>
                            {canEditVoucher &&
                                <Authorization
                                    perform="cardConfigWizard:savePromote"
                                    yes={() => (
                                        <Col className="text-right">
                                            <Button className="btn-host btn-sm" > <i className="fa-solid fa-floppy-disk " onClick={this.savePromote.bind(this)} /></Button>
                                        </Col>
                                    )}
                                    no={() => <div></div>}
                                />
                            }
                        </Row>
                        <hr className="my-1 border-host" />

                        <Row className="mb-2">
                            <Col>
                                <CustomInput type="switch" checked={this.state.voucherConfig.promote} label={<FormattedMessage id="EditVoucher.PromoteVoucher" />} name="promote" id="promote" onChange={this.handleSwitched.bind(this, 'voucherConfig')} />
                            </Col>
                            <Col>
                                {this.state.voucherConfig.promote === true ? <CustomSelect required options={getPromoteTypes()} value={getPromoteTypes().find(el => el.value === this.state.voucherConfig.promoteType)} name={'promoteType'} onChange={this.updateComboForm.bind(this, 'voucherConfig')} placeholder={<FormattedMessage id="CardConfigWizard.ChoosePromotionFlag" />} /> : ''}
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col className="col-2">
                                <FormattedMessage id="EditVoucher.PromoteCode" />
                            </Col>
                            <Col className="col-4">
                                <FormattedMessage id="EditVoucher.PromoteCode" >
                                    {
                                        placeholder => < Input type="text" maxLength="50" name="promoCode" value={this.state.voucherConfig.promoCode ? this.state.voucherConfig.promoCode : ''} onChange={this.updateForm.bind(this, 'voucherConfig')} placeholder={placeholder} ></Input>
                                    }
                                </FormattedMessage>
                            </Col>

                        </Row>
                    </BlankCard>
                </Card>

                <Card className="border-0" style={{ display: (this.state.steps && this.state.steps[7].active === true ? 'block' : 'none'), height: '100%' }}>
                    {this.state.steps && this.state.steps[7].active === true &&
                        <VoucherConfigStep8
                            voucherConfig={this.state.voucherConfig}
                            getNewVoucherRebate={this.getNewVoucherRebate}
                            getConfigDetails={this.getConfigDetails}
                            canEditVoucher={canEditVoucher}
                            voucherId={this.props.match.params.id}
                        />
                    }
                </Card>
            </>

        );
    }
}

export default injectIntl(CardConfigWizard)

const RebateModal = ({ modal, toggleRebateModal, saveRebate, selectedRebate, ReveneuCatList, intl, error, block }) => {
    const [ rebate, setRebate ] = React.useState(selectedRebate);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setRebate({ ...rebate, [name]: value });
    }

    const handleComboChange = (name, selectedOption) => {
        setRebate({ ...rebate, [name]: selectedOption ? selectedOption.value : null });
    }

    
    const updateRebateTerms = (evt, lang) => {
        const multiLingual = rebate.multiLingual ? [...rebate.multiLingual] : [];
        const idx = multiLingual.findIndex(ml => ml.languageCode === lang);

        if (idx >= 0) {
            const ml = { ...multiLingual[idx] };
            ml[evt.target?.name] = evt.target?.value;
            multiLingual[idx] = ml;
            
            setRebate({ ...rebate, multiLingual });
        }
    }

    return (
        <Modal isOpen={modal} toggle={toggleRebateModal} fade={false} className="modal-xl" body >
            <StyledCard title="EditVoucher.AddRebate" error={error} block={block}>
                <Form onSubmit={(e) => saveRebate(e, rebate)}>
                    <Authorization
                        perform="cardConfigWizard:saveService"
                        yes={() => (
                            <Row className="mb-2">
                                <Col className="text-right">
                                    <Button className="btn-host btn-sm" type="submit">
                                        <i className="fa-solid fa-floppy-disk " />
                                    </Button>
                                </Col>
                            </Row>
                        )}
                        no={() => <div></div>}
                    />

                    <Row className="mb-2">
                        <Col className="col-2">
                            <Label><FormattedMessage id="EditVoucher.Code" /></Label>
                        </Col>
                        <Col className="col-4">
                            <Input 
                                name="code"
                                type="text" 
                                placeholder={intl.formatMessage({ id: "EditVoucher.Code" })}
                                required
                                minLength="1"
                                maxLength="50"
                                value={rebate.code}
                                onChange={(e) => handleInputChange(e)} 
                            />
                        </Col>
                        <Col className="col-2">
                            <Label><FormattedMessage id="EditVoucher.MaxQuantity" /></Label>
                        </Col>
                        <Col className="col-4">
                            <Input 
                                name="quantity"
                                type="number"
                                min="1" max="10000"
                                required 
                                placeholder={intl.formatMessage({ id: "EditVoucher.MaxQuantity" })}
                                value={rebate.quantity} 
                                onChange={(e) => handleInputChange(e)}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col className="col-2">
                            <Label><FormattedMessage id="EditVoucher.RevenewCategory" /></Label>
                        </Col>
                        <Col className="col-4">
                            <CustomSelect 
                                style={{ zIndex: '9999' }} 
                                required
                                options={ReveneuCatList} 
                                value={ReveneuCatList.find(el => el.value === rebate.revenueCategoryId)} 
                                name={'revenueCategoryId'} 
                                onChange={(e) => handleComboChange('revenueCategoryId', e)}
                                placeholder={<FormattedMessage id="EditVoucher.RevenewCategory" />} 
                            />
                        </Col>
                        {global.modules?.includes('RebateAction') ?
                            <>
                                <Col className="col-2">
                                    <Label><FormattedMessage id="CardConfigWizard.Action" /></Label>
                                </Col>
                                <Col className="col-4">
                                    <CustomSelect
                                        options={getRebateActions(intl)}
                                        value={getRebateActions(intl).find(opt => opt.value === rebate.action)}
                                        name={'action'}
                                        onChange={(e) => handleComboChange('action', e)}
                                        placeholder=""
                                        required
                                    />
                                </Col>
                            </>
                        : ''}
                    </Row>
                    <Row className="mb-2">
                        <Col className="col-2">
                            <Label><FormattedMessage id="EditVoucher.Description" /></Label>
                        </Col>
                        <Col className="col-10">
                            <MultiLangText textList={rebate.multiLingual} udpateTerms={updateRebateTerms} />
                        </Col>
                    </Row>
                </Form>
            </StyledCard>
        </Modal>
    )
}